module.exports = __webpack_public_path__ + "img/success-image-check-200x200.e9e1985a.svg";